import type { FC, ImgHTMLAttributes } from 'react';

import { LOGO_SRC, LOGO_VARIANT } from './constants';

interface HighlightLogoProps extends ImgHTMLAttributes<HTMLImageElement> {
  variant?: LOGO_VARIANT;
  className?: string;
  testId?: string;
}

const HighlightLogo: FC<HighlightLogoProps> = ({
  variant = LOGO_VARIANT.Color,
  className = 'logo',
  testId,
  ...rest
}) => (
  <img
    alt="Highlight Logo"
    src={`/logos/${LOGO_SRC[variant]}`}
    className={className}
    data-testid={testId}
    {...rest}
  />
);

export default HighlightLogo;
